import ETH from './classify.json';
import BSC from './classify_bsc.json';
import HECO from './classify_heco.json';
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    ETH,
    BSC,
    HECO
}
